export const SIDEBAR = 'sidebar';
export const MODAL = 'modal';

// FIXME MODAL -> OVERLAY
